class OhsTrainingPermissions {
  view: boolean;

  create: boolean;

  edit: boolean;

  signoff: boolean;

  archive: boolean;

  delete: boolean;

  assign_task: boolean;

  constructor(flag: boolean) {
    this.view = flag;
    this.create = flag;
    this.edit = flag;
    this.signoff = flag;
    this.archive = flag;
    this.delete = flag;
    this.assign_task = flag;
  }
}

export default OhsTrainingPermissions;
